import { SwiggyOrderAdapter } from './SwiggyOrderAdapter.js';
import { ZomatoOrderAdapter } from './ZomatoOrderAdapter.js';

/**
 * Factory class for creating order adapters based on partner type
 */
export class OrderAdapterFactory {
    static #adapters = {
        swiggy: new SwiggyOrderAdapter(),
        zomato: new ZomatoOrderAdapter()
    };

    /**
     * Get an adapter instance for a specific partner
     * @param {string} partnerId Partner identifier
     * @returns {BaseOrderAdapter} Order adapter instance
     * @throws {Error} If adapter not found for partner
     */
    static getAdapter(partnerId) {
        const adapter = this.#adapters[partnerId.toLowerCase()];
        if (!adapter) {
            throw new Error(`No adapter found for partner: ${partnerId}`);
        }
        return adapter;
    }

    /**
     * Register a new adapter for a partner
     * @param {string} partnerId Partner identifier
     * @param {BaseOrderAdapter} adapter Adapter instance
     */
    static registerAdapter(partnerId, adapter) {
        this.#adapters[partnerId.toLowerCase()] = adapter;
    }

    /**
     * Check if an adapter exists for a partner
     * @param {string} partnerId Partner identifier
     * @returns {boolean} True if adapter exists
     */
    static hasAdapter(partnerId) {
        return !!this.#adapters[partnerId.toLowerCase()];
    }

    /**
     * Get list of supported partners
     * @returns {string[]} Array of partner identifiers
     */
    static getSupportedPartners() {
        return Object.keys(this.#adapters);
    }
}